import React from 'react'
import Router from './Router';
import {withStyles} from '@material-ui/core';
import Tutorial from 'components/complex/tutorial/Tutorial';
import Save from 'components/popup/save/Save';
import Session from 'components/popup/session/Session';
import pjson from '../../package.json'
import RegisterPopup from 'components/popup/registerPopup/RegisterPopup';
import {connect} from 'react-redux'
import useInitialize from 'hooks/useInitialize';
import usePathParams from 'hooks/usePathParams';
import Loading from 'components/Loading';
import {withRouter} from "react-router";
import {setRedirectFunc, setRedirectWithoutHistoryFunc} from 'redux/actions'
import {SnackbarProvider} from "notistack";
import HookConfirmPopup from "components/popup/confirm/HookConfirmPopup";
import HookAlertPopup from "components/popup/alert/HookAlertPopup";
import HookLoadingScreen from "components/complex/loadingScreen/HookLoadingScreen";
import {SupportModeContextProvider} from "../context/SupportModeContext";

const style = theme => ({
    root: {
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
        minWidth: theme.breakpoints.values.lg
            - theme.scrollSize,
    },
    version: {
        position: 'fixed',
        fontSize: 9,
        bottom: 0,
        right: 0,
        color: theme.palette.text.primary,
    }
})

function Root(
    {
        classes,
        authorizeCounter,
        supportMode,
        location,
        history,
        setRedirectFunc,
        setRedirectWithoutHistoryFunc,
    }) {

    const params = usePathParams(location);
    const canRenderPage = useInitialize(authorizeCounter, params, setRedirectFunc, setRedirectWithoutHistoryFunc, history, location);


    if (!canRenderPage) return (
        <Loading/>
    )

    return (<SupportModeContextProvider value={supportMode}>
            <SnackbarProvider maxSnack={3} anchorOrigin={{horizontal: "center", vertical: "bottom"}}>
                <div className={classes.root}>
                    <Tutorial/>
                    <RegisterPopup/>
                    <Router/>
                    <Save/>
                    <Session/>
                    <HookConfirmPopup/>
                    <HookAlertPopup/>
                    <HookLoadingScreen/>
                    <span className={classes.version}>v{pjson.version}</span>
                </div>
            </SnackbarProvider>
        </SupportModeContextProvider>
    )
}

export default connect((state) => ({
    authorizeCounter: state.authorize.counter,
    supportMode: !!state.resources?.userData?.supportMode,
}), {
    setRedirectFunc,
    setRedirectWithoutHistoryFunc
})(withStyles(style)(withRouter(Root)));
